export const NEW_TIX_THEME_AGENT_NAMES = ["tix.nl", "tix.fr", "flighttix.de"];
export const VLIEGTICKETS_THEME_AGENT_NAMES = [
  "vliegtickets.nl",
  "vliegtickets.be",
];
export const WTC_THEME_AGENT_NAMES = ["wtc.nl"];
export const BDA_THEME_AGENT_NAMES = ["billetdavion.be"];
export const GVT_THEME_AGENT_NAMES = ["goedkopevliegtuigtickets.be"];
export const NEW_GATE1_THEME_AGENT_NAMES: string[] = ["gate1.nl"];
